import { CardHeader } from '@ps/sports-ui-component-library';
import { FeatureFlag } from '@ps/web-core-enums';
import type { EventId } from '@ps/web-sports-api-types';
import React from 'react';

import useFeature from '@swf/core/hooks/useFeature';
import { Icon, SportsLink } from '@swf/sports/components';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import { useNormalisedEventBasedData } from '@swf/sports/hooks/useNormalisedEventBasedData';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import bgImage from '../../../../header-bg.png';
import PopularBetBuilderCount from '../PopularBetBuilderCount/PopularBetBuilderCount';

import styles from './EventDetailsHeader.scss';

interface Props {
  eventId: EventId;
  popularBetBuilderCount: number;
}

const EventDetailsHeader: React.FC<Props> = ({ eventId, popularBetBuilderCount }) => {
  const isFlameVariantEnabled = useFeature(FeatureFlag.ISPExperimentPopularBetBuilderCount);
  const { event, competition, eventType } = useNormalisedEventBasedData({
    eventId
  });

  const { eventSlug, eventStartTime, participants } = event;

  const { competitionId, competitionSlug } = competition;

  const { eventTypeId, eventTypeSlug } = eventType;

  const sportsLinkValues = {
    eventTypeId,
    eventTypeSlug,
    competitionId,
    competitionSlug,
    eventId,
    eventSlug
  };

  return (
    <CardHeader className={styles.cardHeader} style={{ backgroundImage: `url(${bgImage})` }}>
      <div className={styles.eventDetails}>
        <span className={styles.dateTimeContainer}>
          <Icon size="xl" name="clock" className={styles.clockIcon} />
          <FormattedDateTime date={eventStartTime} format="long" weekday="long" />
        </span>
        <SportsLink alias="sportsEvent" values={sportsLinkValues} className={styles.participants}>
          <span>{participants?.[0]}</span>
          <span>{participants?.[1]}</span>
        </SportsLink>
      </div>

      {isFlameVariantEnabled ? (
        <div className={styles.flameWrapper}>
          <PopularBetBuilderCount count={popularBetBuilderCount} />
        </div>
      ) : (
        <Icon size="x3" name={getEventTypeIcon(eventTypeId)} testId="event-type-icon" />
      )}
    </CardHeader>
  );
};

export default EventDetailsHeader;
